import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { api } from './client'

export interface Profile {
  id: number
  amazonProfileId: string
  name: string
  type: string
  marketplace: string
  isActive: number
  hasToken: boolean
  tokenExpiresAt: string | null
}

/** Der API-Client entpackt den ACK-Envelope zu { profiles }. */
export function unwrapProfiles(data: { profiles?: Profile[] }): Profile[] {
  return data.profiles ?? []
}

export function useProfiles(): UseQueryResult<Profile[]> {
  return useQuery({
    queryKey: ['lwa-profiles'],
    queryFn: async () => unwrapProfiles(await api.get<{ profiles: Profile[] }>('/lwa/profiles')),
  })
}
